import { render } from "./request-and-load.vue?vue&type=template&id=c374848c"
import script from "./request-and-load.vue?vue&type=script&lang=js"
export * from "./request-and-load.vue?vue&type=script&lang=js"

import exportComponent from "/Users/agostinodegirolamo/Dropbox/Mac/Documents/Progetti/TTRE/Rapportino/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__